import beats_by_dre from '../images/beats_by_dre.png'
import beats_preview from '../images/beats_preview.jpg'
import bose_headphones from '../images/bose_headphones.png'
import bose_preview from '../images/bose_preview.jpg'
import portfolio_page from '../images/portfolio_page.png'
import portfolio_preview from '../images/portfolio_preview.png'

export const Projects = [
    
    {
        id: 10,
        img: [bose_preview],
        url: "https://www.currys.co.uk/brand/bose/bose-headphones.html",
        pname: "Bose brand shop on Currys",
        desc: "I built a multi-page brand shop to showcase the Bose product range across five categories, including headphones, speakers, soundbars, smart home devices, and wellness devices. Developed with semantic HTML5 and modern CSS, each page was designed with a mobile-first approach and consistent UI patterns to ensure a seamless, responsive browsing experience",
        lgimg: [bose_headphones]
    },
    {
        id: 9,
        img: [beats_preview],
        url: "https://www.currys.co.uk/brand/beats/beats-by-dre.html",
        pname: "Beats brand page on Currys",
        desc: "I developed this responsive landing page to promote the Beats by Dre product range on Currys.co.uk. Built with semantic HTML5 and modern CSS, the layout follows a mobile-first approach and uses Flexbox to create a clean, structured flow of content",
        lgimg: [beats_by_dre]
    },
    {
        id: 5,
        img: "https://portfolio-3e62a.web.app/images/preview/google.jpg",
        url: "https://www.currys.co.uk/brands/google.html",
        pname: "Google brand shop on Currys",
        desc: "A responsive brand page showcasing Google’s product range — from mobile devices to home security systems. Built with semantic HTML and CSS, the page features rich visuals and embedded video to create an engaging and accessible user experience",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/google.jpg"
    },
    {
        id: 2,
        img: "https://portfolio-3e62a.web.app/images/preview/beko.jpg",
        url: "https://www.currys.co.uk/brands/beko/beko-appliances.html",
        pname: "Beko brand shop on Currys",
        desc: "A 7-page brand shop for Beko on Currys.co.uk highlighting a range of products from dishwashers to refrigerators and cooking appliances. I Built this brand shop from Photoshop design assets, the pages were developed using responsive HTML and CSS, with embedded videos to enhance the user experience",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/beko-homepage.jpg"
    },
    {
        id: 3,
        img: "https://portfolio-3e62a.web.app/images/preview/bosch.jpg",
        url: "https://www.currys.co.uk/brands/bosch.html",
        pname: "Bosch brand shop on Currys",
        desc: "A 6-page brand shop for Bosch on Currys.co.uk highlighting a range of products from Cookers to ovens and laundry appliances. I Built this brand shop from Photoshop design assets, the pages were developed using responsive HTML and CSS, with a mobile-first approach using Flexbox to create a clean, structured flow of content",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/bosch-cooking.jpg"
    },
    {
        id: 4,
        img: "https://portfolio-3e62a.web.app/images/preview/intel.jpg",
        url: "https://www.currys.co.uk/brands/intel/intel-everyday.html",
        pname: "Intel brand shop on Currys",
        desc: "I developed this three-page microsite for Intel, adhering to a detailed brief that included Photoshop designs and video assets. I built the pages in responsive HTML and CSS ensuring seamless functionality across devices",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/intel.jpg"
    },
    {
        id: 6,
        img: "https://portfolio-3e62a.web.app/images/preview/sony.jpg",
        url: "https://www.currys.co.uk/brands/sony/sony-alpha-cameras.html",
        pname: "Sony brand shop on Currys",
        desc: "A brand shop for Sony consisting of 10 pages, it showcases a range of Sony products available at Currys. For this project I received a brief consisting of Photoshop designs and Video assets. I built the 10 pages in responsive HTML and CSS and embedded the videos",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/sony-zoom-cameras.jpg"
    },
    {
        id: 7,
        img: "https://portfolio-3e62a.web.app/images/preview/ring.jpg",
        url: "https://www.currys.co.uk/brands/ring/ring-security-cameras.html",
        pname: "Ring brand shop on Currys",
        desc: "A responsive brand page for Ring, focused on showcasing home security products through strong visuals and clear calls to action. Built with HTML and CSS using a mobile-first approach, the layout prioritises accessibility and user engagement across all devices",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/ring.jpg"
    },
    {
        id: 8,
        img: [portfolio_preview],
        url: "https://www.simonlk.com",
        pname: "Portfolio website (React.js)",
        desc: "My personal portfolio website. I built it from the ground up in React.JS, it makes use of modern React features such as Routers, Hooks and Props. It is deployed through a Github repository and is hosted by Netlify",
        lgimg: [portfolio_page]
    },
    /*{
        id: 1,
        img: "https://portfolio-3e62a.web.app/images/preview/cryptobag.jpg",
        url: "https://mycryptobag.netlify.app/",
        pname: "CryptoBag Web App (Nuxt.js)",
        desc: "A crypto tracking Web App that allows you to keep track of all your coins and gauge whether you’re up or down against the market. This app is built in Nuxt.js the SSR version of Vue.js and uses APIs from coingecko and Google Firebase for authentication and database functions.",
        lgimg: "https://portfolio-3e62a.web.app/images/preview-lg/cryptobag-lg.jpg"
    }*/
];